import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import Axios from "axios";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/



const initialValues = {
  email: "",
  password: "",
};

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };


  function login(ev) {
    const data = new FormData();
    data.append('username', email);
    data.append('password', password);
    Axios({
      method: 'post',
      url: process.env.REACT_APP_BACKEND_URL + '/api/token/',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: data,
      validateStatus: (status) => {
        return true;
      },
    })
      .then(response => {
        if (response.data.access) {
          if (response.data.is_staff) {
            document.cookie = `authToken=${response.data.access};`
            setTimeout(() => {
              window.location.reload()
            }, 1000);
          }
        } else {
          alert(response.data.detail)
        }
      })
      .catch(error => {
        return false
      })
  }

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">
          <FormattedMessage id="AUTH.LOGIN.TITLE" />
        </h3>
        <p className="text-muted font-weight-bold">
          Enter your username and password
        </p>
      </div>

      <div className="form-group fv-plugins-icon-container">
        <input
          placeholder="Email"
          type="text"
          className={`form-control form-control-solid h-auto py-5 px-6`}
          name="email"
          onChange={(ev) => setEmail(ev.target.value)}
        />
      </div>
      <div className="form-group fv-plugins-icon-container">
        <input
          placeholder="Password"
          type="password"
          className={`form-control form-control-solid h-auto py-5 px-6`}
          name="password"
          onChange={(ev) => setPassword(ev.target.value)}
        />

      </div>
      <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
        <button
          onClick={(ev) => login(ev)}
          className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
        >
          <span>Sign In</span>
          {loading && <span className="ml-3 spinner spinner-white"></span>}
        </button>
      </div>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
